import { getCurrencyScale, getFormattedPrice } from '@business/utils/currency';
import MultilangText from './MultilangText';
const parseNameLangs = (nameLangs) => {
    if (!nameLangs)
        return {};
    try {
        const parsed = typeof nameLangs === 'string' ? JSON.parse(nameLangs) : nameLangs;
        if (typeof parsed !== 'object' ||
            parsed === null ||
            Array.isArray(parsed)) {
            return {};
        }
        return { nameLang: new MultilangText(parsed) };
    }
    catch (_a) {
        return {};
    }
};
export default class CartTotals {
    constructor(serverData) {
        Object.defineProperty(this, "cart_token", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "deposit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expectedPaymentSchedule", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "externalOffers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "extraAdultCharge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extraChildCharge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fees", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "grandTotal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentSchedule", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "smartPolicyCaptureCreditCard", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "taxes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "taxesAndFees", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "total", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!serverData || !serverData.success || !serverData.data) {
            return;
        }
        const { data: { addAdultsPrice, addKidsPrice, deposit, expectedPaymentSchedule, fees, grandTotal, taxes, total, cart_token, paymentSchedule, rooms, smartPolicyCaptureCreditCard, }, } = serverData;
        this.cart_token = cart_token;
        this.extraAdultCharge = addAdultsPrice || 0;
        this.extraChildCharge = addKidsPrice || 0;
        this.total = total;
        this.deposit = deposit;
        this.grandTotal = grandTotal;
        this.externalOffers = serverData.data.externalOffers || [];
        this.rooms = rooms || [];
        this.taxes = {
            data: taxes.data.map(({ credit, id, name, name_langs }) => (Object.assign({ credit, id: id || '', name: name || '' }, parseNameLangs(name_langs)))),
            total: taxes.total,
        };
        this.fees = {
            data: fees.data.map(({ credit, id, name, name_langs }) => (Object.assign({ credit, id: id || '', name: name || '' }, parseNameLangs(name_langs)))),
            total: fees.total,
        };
        this.taxesAndFees = {
            data: [...this.taxes.data, ...this.fees.data],
            total: this.taxes.total + this.fees.total,
        };
        // Payment-schedule amounts arrive in minor units; convert to major units
        // using the currency's scale (getCurrencyScale): JPY (0) -> unchanged,
        // USD (2) -> ÷100, JOD (3) -> ÷1000. (BENG-2731)
        const transformPaymentSchedule = (schedule) => (schedule || []).map((paymentScheduleItem) => {
            const itemCurrency = (paymentScheduleItem.currency || 'usd').toLowerCase();
            return {
                amount: getFormattedPrice(paymentScheduleItem.amount || 0, getCurrencyScale(itemCurrency)),
                authorize: paymentScheduleItem.authorize,
                currency: itemCurrency,
                isInitialDeposit: paymentScheduleItem.is_initial_deposit,
                orderId: paymentScheduleItem.order_id,
                timestamp: paymentScheduleItem.timestamp,
            };
        });
        this.paymentSchedule = transformPaymentSchedule(paymentSchedule);
        this.expectedPaymentSchedule = transformPaymentSchedule(expectedPaymentSchedule);
        // If the value is not returned from the API, we set it to true by default
        // to keep the behavior of capture credit card in the checkout flow
        this.smartPolicyCaptureCreditCard = smartPolicyCaptureCreditCard !== null && smartPolicyCaptureCreditCard !== void 0 ? smartPolicyCaptureCreditCard : true;
    }
}
